import React from 'react';
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import {setStore} from "trim-redux";
import {withStyles} from "@material-ui/core";
import {Styles} from "../../../../../config/design/styles";
import SubTitle from "../../../../components/elements/SubTitle";
import TrendingUpRoundedIcon from '@material-ui/icons/TrendingUpRounded';
import TrendingDownRoundedIcon from '@material-ui/icons/TrendingDownRounded';
import axios from "axios";
import {defaultVariabls} from "../../../../../config/index";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import TrendingFlatRoundedIcon from '@material-ui/icons/TrendingFlatRounded';
import {Translate} from "../../../../../config/Translate";
import ListItemAvatar from "@material-ui/core/ListItemAvatar/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar/Avatar";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import ListItem from "@material-ui/core/ListItem/ListItem";
import List from "@material-ui/core/List/List";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
import {ChevronLeftRounded} from "@material-ui/icons";
import {truncate} from "../../../../../config/values";
class BestAnalytics extends React.Component {
    state = {
        most_selling_product: null,
        most_selling_shop: null,
        most_reviewed_product: null,
        most_visited_product: null,
        loading:true
    };
    componentDidMount(){
        this.loadData();
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');

        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/analytics/best-analytics`, config)
                .then(response => {
                    this.setState({
                        most_selling_product: response.data.most_selling_product,
                        most_selling_shop: response.data.most_selling_shop,
                        most_reviewed_product: response.data.most_reviewed_product,
                        most_visited_product: response.data.most_visited_product,
                        loading:false
                    })
                }).catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
                loading:false
            });
            this.setState({
                loading:false
            })
        }
    }
    classes = this.props.classes;
    render(){
        let {most_selling_product,most_selling_shop,most_reviewed_product,most_visited_product,loading} = this.state;
        return (
            <>
                {
                   !loading &&
                    <Grid container spacing={2} direction="row" justify="center" alignItems="center">
                        <Grid item xs={12} md={3}>
                            <Grid container  style={{backgroundColor: "#fff",border:"1px solid #232f3e"}} direction="row" alignItems="center" justify="center" className={this.classes.GridAsaPaperBaby}>
                                <Grid item xs={11}>
                                    <SubTitle align="left">{Translate.most_selling_product}</SubTitle>
                                    <List dense >
                                        {most_selling_product.map((item,index) => (
                                            <ListItem
                                                key={index}
                                                button
                                                component="a"
                                                href={`${defaultVariabls.website}/product/${item.slug}`}
                                            >
                                                <ListItemAvatar>
                                                    <Avatar
                                                        variant="rounded"
                                                        alt={item.name}
                                                        src={`${defaultVariabls.uploads}/FileManager/${item.thumbnail.name}_small.${item.thumbnail.extension}`}
                                                    />
                                                </ListItemAvatar>
                                                <ListItemText primary={truncate(item.name,30)} />
                                                <ListItemSecondaryAction>
                                                    <strong>{item.sells}</strong>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Grid container   style={{backgroundColor: "#fff",border:"1px solid #232f3e"}} direction="row" alignItems="center" justify="center" className={this.classes.GridAsaPaperBaby}>
                                <Grid item xs={11}>
                                    <SubTitle align="left">{Translate.most_reviewed_product}</SubTitle>
                                    <List dense >
                                        {most_reviewed_product.map((item,index) => (
                                            <ListItem
                                                key={index}
                                                button
                                                component="a"
                                                href={`${defaultVariabls.website}/product/${item.slug}`}
                                            >
                                                <ListItemAvatar>
                                                    <Avatar
                                                        variant="rounded"
                                                        alt={item.name}
                                                        src={`${defaultVariabls.uploads}/FileManager/${item.thumbnail.name}_small.${item.thumbnail.extension}`}
                                                    />
                                                </ListItemAvatar>
                                                <ListItemText primary={truncate(item.name,30)} />
                                                <ListItemSecondaryAction>
                                                    <strong>{item.reviews_count}</strong>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Grid style={{backgroundColor: "#fff",border:"1px solid #232f3e"}} container   direction="row" alignItems="center" justify="center" className={this.classes.GridAsaPaperBaby}>
                                <Grid item xs={11}>
                                    <SubTitle  align="left">{Translate.most_visited_product}</SubTitle>
                                    <List dense >
                                        {most_visited_product.map((item,index) => (
                                            <ListItem
                                                key={index}
                                                button
                                                component="a"
                                                href={`${defaultVariabls.website}/product/${item.slug}`}
                                            >
                                                <ListItemAvatar>
                                                    <Avatar
                                                        variant="rounded"
                                                        alt={item.name}
                                                        src={`${defaultVariabls.uploads}/FileManager/${item.thumbnail.name}_small.${item.thumbnail.extension}`}
                                                    />
                                                </ListItemAvatar>
                                                <ListItemText primary={truncate(item.name,30)} />
                                                <ListItemSecondaryAction>
                                                    <strong>{item.total_visits}</strong>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Grid container  style={{backgroundColor: "#fff",border:"1px solid #232f3e"}} direction="row" alignItems="center" justify="center" className={this.classes.GridAsaPaperBaby}>
                                <Grid item xs={11}>
                                    <SubTitle align="left">{Translate.most_selling_shop}</SubTitle>
                                    <List dense >
                                        {most_selling_shop.map((item,index) => (
                                            <ListItem
                                                key={index}
                                                button
                                                component="a"
                                                href={`${defaultVariabls.website}/vendor/${item.slug}`}
                                            >
                                                <ListItemAvatar>
                                                    <Avatar
                                                        alt={item.name}
                                                        src={`${defaultVariabls.uploads}/FileManager/${item.logo.name}_small.${item.logo.extension}`}
                                                    />
                                                </ListItemAvatar>
                                                <ListItemText primary={truncate(item.name,30)} />
                                                <ListItemSecondaryAction>
                                                    <strong>{item.total_sales}</strong>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                }

            </>

        );
    }
}

export default withStyles(Styles)(BestAnalytics);